<template>
    <v-container grid-list-lg>
        <v-layout row wrap style="padding-bottom:20px"> 
               <v-loading class="loading" v-model="loading" v-if="loading">
    
                    <v-progress-circular persistent
                    :size="70"
                    :width="7"
                    color="primary"
                    indeterminate
                    ></v-progress-circular>
            
                </v-loading>
                <v-toolbar dark color="primary">
                    <v-toolbar-title>Lista de eventos</v-toolbar-title>
                    <v-btn v-if="perfil == 2 || perfil == 3" flat to="/criar-evento" outline color="white"  style="position:absolute; right:20px; top:7px">Novo</v-btn>
                </v-toolbar>
                <!--v-flex v-for="i in 10" :key="`4${i}`" xs12 sm8 md4-->
                <!--v-flex v-for="(fotografo, idx) in 10" :key="idx" xs12 sm8 md4-->
                <v-flex v-for="(item, index) in items" xs12 sm6 md4 row style="margin-bottom:20px; padding:0px">
                    
                    <v-card>
                        <img v-if="item.img != 'null'" :src="item.img" class="imagem" />
                        <v-card-text>
                            <v-btn class="deletar" v-if="perfil == 2 || perfil == 3" flat color="orange" flat="flat" @click="deletarItem(item.slug)">x</v-btn>
                            
                                <!--div class="imagem"  style="background-image: url('http://www.closebecoming.co.uk/images/category_10/Honey%20%20B%20Women%20Black%20Self%20Design%20Top%20Beautiful%20BLOVOT.jpg');" ></div-->
                                <div style="width:100%" class="body-content">
                                    
                                    <div style="float:left; width:100%">
                                        <div class="etiqueta nao-iniciado" v-if="item.dateStartSemHifen > dataAtual">Não iniciado</div>
                                        <div class="etiqueta finalizado" v-if="item.dateEndSemHifen < dataAtual">Finalizado</div>
                                        <div class="etiqueta em-andamento" v-if="item.dateStartSemHifen < dataAtual && item.dateEndSemHifen > dataAtual">Em andamento</div>
                                    </div><br />
                                    
                                    <h3 class="headline mb-0" :title="item.texto">{{item.titulo}}</h3> <!-- {{ parentMessage }} - {{ index }} - {{ item.message }} -->
                                    <div>Data de inicio: {{item.dataInicio}}</div>
                                    <div>Data final: {{item.dataFinal}}</div>
                                    <div>{{item.descricao}}</div><br />
                                    <div class="confirmacoes" :data-slug-confirmacoes="item.slug" @click="confirmacoes(item.slug)"><b>Confirmações(<span>0</span>)</b></div><br />
                                    
                                </div>
                            
                            <v-card-actions>
                                <v-btn v-if="perfil == 2 || perfil == 3" class="editar" flat color="orange" flat="flat" @click="editarItem(item.slug)">Editar</v-btn>
                                <v-btn v-if="item.dateEndSemHifen > dataAtual" :data-slug="item.slug" class="release confirmacao" flat color="orange" flat="flat" @click="confirmarPresenca(item.slug)">Confirmar presença!</v-btn>
                            </v-card-actions>
                            
                        </v-card-text>
                    
                    </v-card>
                </v-flex>
                
            

                
            
        </v-layout>
        <v-dialog v-model="dialogDeleteConfirm" persistent max-width="290">
            <v-card>
                <v-card-title class="headline">Deletar evento?</v-card-title>
                <!--v-card-text>Let Google help apps determine location. This means sending anonymous location data to Google, even when no apps are running.</v-card-text-->
                <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="green darken-1" flat @click="dialogDeleteConfirm = false">Não</v-btn>
                <v-btn color="green darken-1" flat @click="deletarItemConfirm">Sim</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <v-dialog v-model="dialog" persistent max-width="290">
            <v-card>
                <v-card-title class="headline">Evento deletado com sucesso!</v-card-title>
                <!--v-card-text>Let Google help apps determine location. This means sending anonymous location data to Google, even when no apps are running.</v-card-text-->
                <v-card-actions>
                <v-spacer></v-spacer>
                <!--v-btn color="green darken-1" flat @click="dialog = false">Disagree</v-btn-->
                <v-btn color="green darken-1" flat @click="dialog = false">OK</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <v-dialog v-model="dialogConfirmacoes" max-width="100%">
            
            <v-card>
                <a class="closeModal" @click="dialogConfirmacoes = false">x</a>
                <v-card-title class="headline">Confirmados({{quantidadeConfirmacoes}})</v-card-title><br />
                <!--v-card-text>Let Google help apps determine location. This means sending anonymous location data to Google, even when no apps are running.</v-card-text-->
                <v-flex v-for="(item, index) in itemsConfirmacoesModal">
                    <div class="itens-container">
                                    <div class="img" v-bind:style="{ 'background-image': 'url(' + item.img + ')' }" ></div>
                                    <div class="body-content">
                                        
                                        <b :title="item.nome">{{item.nome}}</b> <!-- {{ parentMessage }} - {{ index }} - {{ item.message }} -->
                                        
                                    </div>
                                
                                <!--v-card-actions>
                                    <div class="instagram" style="height:20px;"><a @click="diarioFiltradoPorAluno(item.slugAluno)">Diário</a></div>
                                    <v-btn class="editar" flat color="orange" flat="flat" @click="chegou(item.slugAluno)">Chegou</v-btn>
                                    <v-btn class="release" flat color="orange" flat="flat" @click="saiu(item.slugAluno)">Saiu</v-btn>
                                    
                                </v-card-actions-->
                        </div>
                    </v-flex>
                <v-card-actions>
                    
                <v-spacer></v-spacer>
                <!--v-btn color="green darken-1" flat @click="dialog = false">Disagree</v-btn-->
                <v-btn color="green darken-1" flat @click="dialogConfirmacoes = false">OK</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </v-container>
</template>

<script>

import db from './firebaseInit';
import firebase from 'firebase';

import { userProperties, usersData } from '@/global.js';

export default {
    name: 'Eventos-Listagem',
    data () {
        return {
            slug : '',
            dialogDeleteConfirm: false,
            dialog: false,
            loading: false,
            perfil: userProperties.perfil,
            modalMessage: 'Evento excluído com sucesso!',
            items: [],
            slugClicado: null,
            itemsConfirmacoesModal: [],
            quantidadeConfirmacoes: 0,
            dialogConfirmacoes: false,
            dataAtual: null
        }
    },
    methods: {
        carregaDados() {
            this.fnDataAtual();
            // ordernar exibicao - numerica
            function ordenarPorTimestamp(a, b){
                //return a.dataNumero - b.dataNumero; // crescente
                return b.ordenacao - a.ordenacao; // decrescente
            }

            this.items = []
            this.loading = true
            let obj = []
            
            db.collection("eventos")
            .where("escolaID", "==", userProperties.escolaID)
            .get()
            .then((querySnapshot) => {
                if(querySnapshot.size == 0){
                    this.loading = false;
                    alert("Nenhum evento foi criado.");
                }
                else{
                    querySnapshot.forEach(doc => {
                    
                        // doc.data() is never undefined for query doc snapshots
                        //console.log(doc.id, " => ", doc.data());                    
                        let customObj = doc.data()

                        var storageRef = firebase.storage().ref();
                        var tangRef = storageRef.child('eventos/'+customObj.slug+'.'+customObj.extensao);

                        function getSubCollection(){
                            // Build doc ref from doc.id
                            var quantidadeConfirmacoes = null;
                            var statusConfirmacao = false
                            db.collection("eventos").doc(doc.id).collection("confirmacoes")
                            .get()
                            .then((querySnapshot) => {
                                quantidadeConfirmacoes = querySnapshot.size;
                                querySnapshot.forEach(doc => {
                                    // doc.data() is never undefined for query doc snapshots
                                    console.log(doc.id, " => ", doc.data());                    
                                    let customObjConfirmacao = doc.data();

                                    // seta a quantidade de confirmacoes
                                    $( "button[data-slug='"+customObj.slug+"']" ).parent().prev().find(".confirmacoes span").text(quantidadeConfirmacoes);

                                    if(customObjConfirmacao.slugAutor == userProperties.slug){
                                        $( "button[data-slug='"+customObj.slug+"']" ).find("div").text("Confirmado!");
                                        $( "button[data-slug='"+customObj.slug+"']" ).removeClass("confirmacao");
                                        $( "button[data-slug='"+customObj.slug+"']" ).addClass("confirmado");
                                        statusConfirmacao = true;
                                    }
                                })
                            })
                        }

                        tangRef.getDownloadURL().then(urlImgFB =>                             {
                            // Once we have the download URL, we set it to our img element
                            //console.log(urlImgFB);
                            this.items.push({"titulo": customObj.titulo, "descricao": customObj.descricao, "push": customObj.push, "preview": customObj.preview, "ordenacao":customObj.dateStart.replace(/-/g, ''), "dateStart": customObj.dateStart, "dateEnd": customObj.dateEnd, "exibicaoName": customObj.exibicaoName, "slug": customObj.slug, "extensao": customObj.extensao, "img": urlImgFB, "slugAutor": customObj.slugAutor, "dataInicio": customObj.dateStart.split("-")[2] + "/" + customObj.dateStart.split("-")[1] + "/" + customObj.dateStart.split("-")[0], "dataFinal": customObj.dateEnd.split("-")[2] + "/" + customObj.dateEnd.split("-")[1] + "/" + customObj.dateEnd.split("-")[0], "dateStartSemHifen": customObj.dateStart.replace(/-/g, ''), "dateEndSemHifen": customObj.dateEnd.replace(/-/g, '')});
                            this.slug = customObj.slug;
                            this.items.sort(ordenarPorTimestamp)
                            getSubCollection();

                        }).catch(error => {
                            // If anything goes wrong while getting the download URL, log the error,
                            this.items.push({"titulo": customObj.titulo, "descricao": customObj.descricao, "push": customObj.push, "preview": customObj.preview, "ordenacao":customObj.dateStart.replace(/-/g, ''), "dateStart": customObj.dateStart, "dateEnd": customObj.dateEnd, "exibicaoName": customObj.exibicaoName, "slug": customObj.slug, "img": "null", "slugAutor": customObj.slugAutor, "dataInicio": customObj.dateStart.split("-")[2] + "/" + customObj.dateStart.split("-")[1] + "/" + customObj.dateStart.split("-")[0], "dataFinal": customObj.dateEnd.split("-")[2] + "/" + customObj.dateEnd.split("-")[1] + "/" + customObj.dateEnd.split("-")[0], "dateStartSemHifen": customObj.dateStart.replace(/-/g, ''), "dateEndSemHifen": customObj.dateEnd.replace(/-/g, '')});
                            this.slug = customObj.slug;
                            this.items.sort(ordenarPorTimestamp)
                            getSubCollection();
                        });
                        
                        this.loading = false
                        
                    });
                }
                
            });
            console.log(this.items);

            
                //clearInterval(myInterval8);
            // this.items = obj
            // console.log("XXXXXX"+obj)
        },
        fnDataAtual(){
            // timestamp
                var now = new Date();
                var year = "" + now.getFullYear();
                var month = "" + (now.getMonth() + 1); if (month.length == 1) { month = "0" + month; }
                var day = "" + now.getDate(); if (day.length == 1) { day = "0" + day; }
                // var hour = "" + now.getHours(); if (hour.length == 1) { hour = "0" + hour; }
                // var minute = "" + now.getMinutes(); if (minute.length == 1) { minute = "0" + minute; }
                // var second = "" + now.getSeconds(); if (second.length == 1) { second = "0" + second; }
                // //return year + "-" + month + "-" + day + " " + hour + ":" + minute + ":" + second;
                this.dataAtual = year + month + day;
        },
        confirmarPresenca(slug){
            //this.$router.push(`/Editar-Evento/?slug=`+slug)
            this.loading = true
            var that = this;
            var slugConfirmacao = that.generateUUID();
            if($( "button[data-slug='"+slug+"']" ).find("div").text() != "Confirmado!"){
                $( "button[data-slug='"+slug+"']" ).find("div").text("Confirmado!");
                $( "button[data-slug='"+slug+"']" ).removeClass("confirmacao");
                $( "button[data-slug='"+slug+"']" ).addClass("confirmado");
                var qndConfirm = $( "div[data-slug-confirmacoes='"+slug+"'] span" ).text();
                qndConfirm = Number(qndConfirm) + 1;
                $( "div[data-slug-confirmacoes='"+slug+"'] span" ).text(qndConfirm);
                
                db.collection("eventos").where("escolaID", "==", userProperties.escolaID).where("slug", "==", slug)
                .get()
                .then((querySnapshot) => {
                    querySnapshot.forEach(doc => {
                        console.log(doc.id, " => ", doc.data());
                        // Build doc ref from doc.id
                        db.collection("eventos").doc(doc.id).collection('confirmacoes').add({
                            "slug":slugConfirmacao, 
                            "slugAutor":userProperties.slug
                            //texto: "testeabc" 
                            
                        }).then(docRef => {
                            //this.$router.push(`/${slug}/success`)
                            
                            console.log('Evento confirmado com sucesso');

                            // Log do sistema
                            // timestamp
                            var now = new Date();
                            var year = "" + now.getFullYear();
                            var month = "" + (now.getMonth() + 1); if (month.length == 1) { month = "0" + month; }
                            var day = "" + now.getDate(); if (day.length == 1) { day = "0" + day; }
                            var hour = "" + now.getHours(); if (hour.length == 1) { hour = "0" + hour; }
                            var minute = "" + now.getMinutes(); if (minute.length == 1) { minute = "0" + minute; }
                            var second = "" + now.getSeconds(); if (second.length == 1) { second = "0" + second; }
                            //return year + "-" + month + "-" + day + " " + hour + ":" + minute + ":" + second;
                            var customtimestamp = year + month + day + hour + minute + second

                            db.collection('log_' + userProperties.escolaID).add({
                                    escolaID: userProperties.escolaID,
                                    slugAutor: userProperties.slug,
                                    
                                    slug: that.slug,
                                    customtimestamp: customtimestamp,
                                    dia: day,
                                    mes: month,
                                    ano: year,
                                    acao: "confirmacao",
                                    categoria: "eventos",
                                    pontos: 4
                                    
                                })
                                .then(docRef => {
                                    console.log('Document written with ID: ', docRef.id);
                                    this.loading = false
                                    
                                })
                                .catch((error) => {
                                    console.log('Error adding document: ', error);
                                    console.log("Erro no envio dos dados. Tente novamente mais tarde!")
                                    this.loading = false
                                })
                                
                        })
                        .catch((error) => {
                            console.log('Error adding document: ', error);
                        })

                    });
                })
            }
            
        },
        editarItem(slug){
            this.$router.push(`/Editar-Evento/?slug=`+slug)

        },
        displayItem(slug){
            this.$router.push(`/Display-Evento/?slug=`+slug)

        },
        deletarItem(slug){
            this.slug = slug;
            this.dialogDeleteConfirm = true;
        },
        deletarItemConfirm(){
            var slug = this.slug;
            this.loading = true
            db.collection("eventos").where("slug", "==", slug)
            .get()
            .then(querySnapshot => {
                querySnapshot.forEach((doc) => {
                    doc.ref.delete().then(() => {
                    this.dialog = true
                    console.log("Document successfully deleted!");
                    }).catch(function(error) {
                    console.error("Error removing document: ", error);
                    });
                });
                this.loading = false
                this.dialogDeleteConfirm = false;
                this.carregaDados();
            })
            .catch(function(error) {
                console.log("Error getting documents: ", error);
                this.loading = false;
                this.dialogDeleteConfirm = false;
                alert("Error while trying to delete, please try again.");
            });
        },
        generateUUID () {
          let d = new Date().getTime()
          let uuid = 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
            let r = (d + Math.random() * 16) % 16 | 0
            d = Math.floor(d / 16)
            return (c === 'x' ? r : (r & 0x3 | 0x8)).toString(16)
          })
          return uuid
        },
        closeModal() {
            this.dialog = false      
            this.$router.push(`/`)
            this.$forceUpdate()
            Vue.delete(state.fixture, i)
        },
        confirmacoes(slug){
            this.loading = true
            db.collection("eventos")
            .where("escolaID", "==", userProperties.escolaID).where("slug", "==", slug)
            .get()
            .then((querySnapshot) => {
                querySnapshot.forEach(doc => {
                    
                    // doc.data() is never undefined for query doc snapshots
                    //console.log(doc.id, " => ", doc.data());                    
                    let customObj = doc.data()
                    this.itemsConfirmacoesModal = [];
                    // Build doc ref from doc.id
                    db.collection("eventos").doc(doc.id).collection("confirmacoes")
                        .get()
                        .then((querySnapshot) => {
                            var quantidadeConfirmacoes = querySnapshot.size;
                            if(quantidadeConfirmacoes == 0){
                                alert("Esse evento ainda não possui confirmações. Seja o primeiro(a)!")
                            }
                            else{
                                
                                querySnapshot.forEach(doc => {
                                    // doc.data() is never undefined for query doc snapshots
                                    //console.log(doc.id, " => ", doc.data());
                                    var customObjConfirmacao = doc.data()
                                    //console.log(customObjConfirmacao);                    
                                    
                                    this.itemsConfirmacoesModal.push(customObjConfirmacao.slugAutor);
                                })

                            }
                            this.quantidadeConfirmacoes = quantidadeConfirmacoes;
                            this.dialogConfirmacoes = true;
                            
                            // Busca nome pelo Slug
                            //var responsaveisDoAlunoSlug = [];
                            var fullObject = [];
                            
                            this.itemsConfirmacoesModal.forEach((item, index) => {
                                usersData.usuarios.forEach((item2, index2) => {
                                    //console.log("item = "+ item);
                                    //console.log("item2.slug = "+ item2.slug);
                                    if(item == item2.slug){
                                        var storageRef = firebase.storage().ref();
                                        
                                        var tangRef = storageRef.child('profile/'+item+'.'+item2.extensao);

                                        tangRef.getDownloadURL().then(urlImgFB =>                             {
                                            // Once we have the download URL, we set it to our img element
                                            //console.log(urlImgFB);
                                            fullObject.push({"slug":item, "extensao": item2.extensao, "nome": item2.nome, "img":urlImgFB});

                                            }).catch(error => {
                                                // If anything goes wrong while getting the download URL, log the error,
                                                fullObject.push({"slug":item, "extensao": item2.extensao, "nome": item2.nome});
                                        });
                                        
                                    }
                                });
                            });
                            this.itemsConfirmacoesModal = fullObject;
                            console.log(fullObject)
                        })

                    // function getSubCollection(){
                    
                    //     
                    // }

                    // var storageRef = firebase.storage().ref(); 
                    // var tangRef = storageRef.child('eventos/'+customObj.slug+'.'+customObj.extensao);

                    // tangRef.getDownloadURL().then(urlImgFB =>                             {
                    //     // Once we have the download URL, we set it to our img element
                    //     //console.log(urlImgFB);
                    //     this.items.push({"titulo": customObj.titulo, "descricao": customObj.descricao, "push": customObj.push, "preview": customObj.preview, "ordenacao":customObj.dateStart.replace(/-/g, ''), "dateStart": customObj.dateStart, "dateEnd": customObj.dateEnd, "exibicaoName": customObj.exibicaoName, "slug": customObj.slug, "extensao": customObj.extensao, "img": urlImgFB});
                    //     this.slug = customObj.slug;
                    //     this.items.sort(ordenarPorTimestamp)
                    //     getSubCollection();

                    // }).catch(error => {
                    //     // If anything goes wrong while getting the download URL, log the error,
                    //     this.items.push({"titulo": customObj.titulo, "descricao": customObj.descricao, "push": customObj.push, "preview": customObj.preview, "ordenacao":customObj.dateStart.replace(/-/g, ''), "dateStart": customObj.dateStart, "dateEnd": customObj.dateEnd, "exibicaoName": customObj.exibicaoName, "slug": customObj.slug, "img": "null"});
                    //     this.slug = customObj.slug;
                    //     this.items.sort(ordenarPorTimestamp)
                    //     getSubCollection();
                    // });

                    this.loading = false
                    
                });
            });
        }
            
        
    },
    created() {
        this.carregaDados();
    }
};



</script>

<style scoped>
    .loading{
        position: fixed;
        top:20%;
        left:41%;
        z-index: 2;
    }

    .deletar{
        position: absolute;
        min-width: auto;
        height: auto;
        padding: 1px 6px !important;
        right: 0;
        top: 0;
    }

    .release{
        background-color:beige;
        position:xabsolute;
        right: 12px;
    }

    .editar{
        background-color:beige;
        position:absolute;
        right: 12px;
    }

    .imagem{
        width: 100%;
        height: auto;
    }

    .confirmado{
        background-color: #4CAF50 !important;
        border-color: #4CAF50 !important;
        color: #fff !important;
    }

    .img{
        width: 50px;
        height: 50px;
        margin-right: 12px;
        border:beige solid 1px;
        border-radius: 50%;
        background-position: center top;
        background-size: 100% auto;
        position: relative;
        top:-6px;
        float: left;
        margin-left:12px;
    }
    
    .itens-container{
        float: left;
        width: 100%;
        margin-bottom: 9px;
    }

    .itens-container .body-content{
        margin-top: 5px;
    }
    
    .closeModal{
        float: right;
        color:#000;
        margin: 5px 14px;
    }
    .v-dialog--active .v-card__actions{
        height: 50px;
    }

    .etiqueta{
        color: #fff;
        padding: 3px 10px;
        float: left;
    }

    .nao-iniciado{
        background: orange;
    }

    .finalizado{
        background: red;
    }

    .em-andamento{
        background: green;
    }
</style>
